/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface InsightfulnessCriterion
 */
export interface InsightfulnessCriterion {
  /**
   *
   * @type {number}
   * @memberof InsightfulnessCriterion
   */
  readonly id: number;
  /**
   *
   * @type {string}
   * @memberof InsightfulnessCriterion
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof InsightfulnessCriterion
   */
  definition: string;
  /**
   *
   * @type {string}
   * @memberof InsightfulnessCriterion
   */
  example: string;
}

/**
 * Check if a given object implements the InsightfulnessCriterion interface.
 */
export function instanceOfInsightfulnessCriterion(value: object): value is InsightfulnessCriterion {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('name' in value) || value['name'] === undefined) return false;
  if (!('definition' in value) || value['definition'] === undefined) return false;
  if (!('example' in value) || value['example'] === undefined) return false;
  return true;
}

export function InsightfulnessCriterionFromJSON(json: any): InsightfulnessCriterion {
  return InsightfulnessCriterionFromJSONTyped(json, false);
}

export function InsightfulnessCriterionFromJSONTyped(json: any, ignoreDiscriminator: boolean): InsightfulnessCriterion {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    name: json['name'],
    definition: json['definition'],
    example: json['example'],
  };
}

export function InsightfulnessCriterionToJSON(value?: Omit<InsightfulnessCriterion, 'id'> | null): any {
  if (value == null) {
    return value;
  }
  return {
    name: value['name'],
    definition: value['definition'],
    example: value['example'],
  };
}
